import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",  //首页
        name: "home",
        meta: {
            showHeader: true,
            showNavbar: true,
        },
        component: () => import('@/views/home/index.vue'),
    },
    {
        path: "/customer", //客服
        name: "customer",
        meta: {
            showHeader: true
        },
        component: () => import('@/views/customer/index.vue')
    },
    {
        path: "/deposit",  //充值
        name: "deposit",
        component: () => import('@/views/deposit/index.vue')
    },
    {
        path: "/withdraw",  //提现
        name: "withdraw",
        component: () => import('@/views/withdraw/index.vue')
    },
    {
        path: "/orderView",  //提现进度详情
        name: "orderView",
        component: () => import('@/views/withdraw/orderView/index.vue')
    },
    {
        path: "/history", //记录
        name: "history",
        component: () => import('@/views/history/index.vue')
    },
    {
        path: "/activitys", //活动列表
        name: "activitys",
        meta: {
            showHeader: true,
            showNavbar: true,
        },
        component: () => import('@/views/activitys/index.vue')
    },
    {
        path: "/userInfo", //个人信息
        name: "userInfo",
        meta: {
            showHeader: true,
            showNavbar: true,
        },
        component: () => import('@/views/userInfo/index.vue')
    },
    {
        path: "/cashBack", //新手专属奖励
        name: "cashBack",
        meta: {
            activityId: 1
        },
        component: () => import('@/views/activitys/cashBack/index.vue')
    },
    {
        path: "/vip", //新手专属奖励
        name: "vip",
        meta: {
            activityId: 2
        },
        component: () => import('@/views/activitys/vip/index.vue')
    },
    {
        path: "/agent", //代理活动
        name: "agent",
        meta: {
            activityId: 4
        },
        component: () => import('@/views/activitys/agent/index.vue')
    },
    {
        path: "/share",  //邀请
        name: "share",
        meta: {
            activityId: 3
        },
        component: () => import('@/views/activitys/share/index.vue')
    },
    {
        path: "/betBack",  //下注返现
        name: "betBack",
        meta: {
            activityId: 5
        },
        component: () => import('@/views/activitys/betBack/index.vue')
    },
    {
        path: "/lossBack",  //亏损返现活动
        name: "lossBack",
        meta: {
            activityId: 6
        },
        component: () => import('@/views/activitys/lossBack/index.vue')
    },
    {
        path: "/wdTask",  //提现任务
        name: "wdTask",
        meta: {
            activityId: 7
        },
        component: () => import('@/views/activitys/wdTask/index.vue')
    },
    {
        path: "/edit",  //提现账户绑定界面
        name: "edit",
        component: () => import('@/views/edit/index.vue')
    },
    {
        path: "/gameTimes",  //选择场次界面
        name: "gameTimes",
        meta: {
            showHeader: true,
        },
        component: () => import('@/views/gameTimes/gameTimes.vue')
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
